import React from 'react';
import { NextPage } from 'next';
import { Page as Component } from '~/components/specifics/property_deals/[id]/Page';
import { NskHead } from '~/components/common/head/NskHead';

export const PATH = (id: number): string => `/property_deals/${id}`;

const Home: NextPage = () => (
  <>
    <NskHead title="案件グループ" />
    <Component />
  </>
);

export default Home;
